import React, { useRef } from 'react';

/**
 * Card3DHover - wraps children and applies 3D hover effect
 * Usage: <Card3DHover><div className="client-card">...</div></Card3DHover>
 */
const Card3DHover = ({ children, maxTilt = 18, scale = 1.04 }) => {
  const ref = useRef(null);

  const handleMouseMove = (e) => {
    const card = ref.current;
    if (!card) return;
    const rect = card.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    const centerX = rect.width / 2;
    const centerY = rect.height / 2;
    const rotateX = ((y - centerY) / centerY) * maxTilt;
    const rotateY = ((x - centerX) / centerX) * -maxTilt;
    card.style.transform = `perspective(900px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale3d(${scale},${scale},${scale})`;
    card.style.transition = 'transform 0.1s cubic-bezier(.03,.98,.52,.99)';
  };

  const handleMouseLeave = () => {
    const card = ref.current;
    if (!card) return;
    card.style.transform = 'perspective(900px) rotateX(0deg) rotateY(0deg) scale3d(1,1,1)';
    card.style.transition = 'transform 0.45s cubic-bezier(.03,.98,.52,.99)';
  };

  return React.cloneElement(children, {
    ref,
    onMouseMove: handleMouseMove,
    onMouseLeave: handleMouseLeave,
    style: { willChange: 'transform', ...children.props.style },
  });
};

export default Card3DHover;
